import React, { useState } from "react";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";
import {
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { hasFotovoltaico } from "api/onboardingTypes";
import { useGreenEnergyContext } from "contexts/GreenEnergyContext";
import { useSetError, useErrorInfo } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";

const FRAME_DATA = {
  title: "Buscar melhores soluções",
  h2Subtitle: "Possui sistema Fotovoltaico no imóvel?",
  buttonText: "Continuar",
  nextScreen: "consumer-bill-upload",
  imgSrc: "/static/img/solutions/fotovoltaico.png",
  skipTo: {
    pathname: "consumer-bill-upload",
    state: { from: "/onboarding/building-has-fv" },
  },
};

const FOTOVOLTAICO_DATA: Array<{ value: hasFotovoltaico; text: string }> = [
  {
    value: "Sim",
    text: "Sim",
  },
  {
    value: "Não",
    text: "Não",
  },
];

export const BuildinghasFV = ({ history }) => {
  const [status, setStatus] = useState<hasFotovoltaico>();
  const { sethasfotovoltaico } = useGreenEnergyContext();
  const setGlobalError = useSetError();
  const errorInfo = useErrorInfo();
  const hasFormError = errorInfo?.code === CustomCodes.INCOMPLETE_FORM;

  const handleSubmit = () => {
    if (status) {
      sethasfotovoltaico(status);
      history.push({
        pathname: `/onboarding/${FRAME_DATA.nextScreen}`,
        state: { from: "/onboarding/building-has-fv" },
      });
    } else {
      setGlobalError(CustomCodes.INCOMPLETE_FORM);
    }
  };

  return (
    <SolutionsFrame {...FRAME_DATA} onButtonClick={handleSubmit}>
      <BlockStandard hideDivider>
        <List>
          {FOTOVOLTAICO_DATA.map(({ value, text }) => (
            <ListItem
              disablePadding
              key={value}
              sx={{
                border: `1px solid ${hasFormError && !status ? "red" : "#595959"}`,
                borderRadius: "12px",
                mb: 2,
              }}
            >
              <ListItemButton onClick={() => setStatus(value)}>
                <ListItemIcon>
                  <Checkbox
                    sx={{ color: "#595959" }}
                    color="success"
                    edge="start"
                    checked={status === value}
                  />
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </BlockStandard>
    </SolutionsFrame>
  );
};
